// ehrPrepopulationMessage
export const PREPOPULATION_MESSAGE_DEFAULT = "default";
export const PREPOPULATION_MESSAGE_NO_VALUE = "no_value";
export const PREPOPULATION_MESSAGE_HIDDEN = "hidden";
